"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpBadges: {
        badgeMore: 'More',
    },
};
